"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation createVideo($organisationId: String!, $input: NewVideoInput!, $folderId: String, $projectId: String) {\n    createVideo(organisationId: $organisationId, input: $input, folderId: $folderId, projectId: $projectId) {\n      videoId\n      brandId\n      organisationId\n      videoProjectId\n      createdByUserId\n      creator {\n        firstName\n        lastName\n      }\n      lowerThirdId\n      introAnimationId\n      assetIds\n      outputs {\n        outputId\n        isMaster\n        name\n        versions {\n          versionId\n          outputId\n          assetId\n          versionNumber\n          appliedAddons {\n            BURN_IN_CAPTIONS {\n              value\n            }\n            SRT_CAPTIONS {\n              value\n            }\n            CHROMA_KEY {\n              value\n            }\n            RUSH_EDIT {\n              value\n            }\n            DURATION {\n              value\n            }\n          }\n        }\n        latestVersion\n        status {\n          name\n        }\n        aspectRatio\n      }\n      presenters {\n        presenterId\n        name\n        title\n        description\n        imageKey\n      }\n      clips {\n        clipId\n        isImage\n        clipStartTime\n        duration\n        originalDuration\n        startTime\n        assetId\n        layerIndex\n      }\n      name\n      videoType\n      notesToTheEditor\n      creativeInput\n      targetAudience\n      keyMessage\n      callToAction\n      musicStyle\n      videoStyle\n      lowerThirdTitle\n      lowerThirdDescription\n      permissions\n      editingMode\n      createdAt\n      submittedAt\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var createVideoQuery = (0, _graphqlTag.default)(_templateObject());

var createVideo = function createVideo(organisationId) {
  return {
    mutation: createVideoQuery,
    module: 'video',
    buildVariables: function buildVariables(_ref) {
      var name = _ref.name,
          videoFolderId = _ref.videoFolderId,
          videoProjectId = _ref.videoProjectId;
      return {
        organisationId: organisationId,
        folderId: videoFolderId,
        projectId: videoProjectId,
        input: {
          name: name,
          submittedTimezone: _momentTimezone.default.tz.guess()
        }
      };
    }
  };
};

var _default = createVideo;
exports.default = _default;